import { EStrategyOptionsName, IStrategy } from '@/modules/CampaignsModule/interfaces/Campaigns';

const TRANSLATE_MODAL = 'CAMPAIGNS_MAIN.CREATE_EDIT_CAMPAIGNS';
const TRANSLATE_MODAL_INPUTS = `${TRANSLATE_MODAL}.INPUTS_FORM`;

const STRATEGY_OPTIONS: IStrategy[] = [
  { strategyId: 1, name: EStrategyOptionsName.MARKETING },
  { strategyId: 2, name: EStrategyOptionsName.SALES },
  { strategyId: 3, name: EStrategyOptionsName.REMARKETING },
  { strategyId: 4, name: EStrategyOptionsName.NURTURING },
  { strategyId: 5, name: EStrategyOptionsName.LEAD_GENERATION },
  { strategyId: 6, name: EStrategyOptionsName.LEAD_RECOVERY },
  { strategyId: 7, name: EStrategyOptionsName.CROSS_SELLING },
  { strategyId: 8, name: EStrategyOptionsName.UP_SELLING },
  { strategyId: 9, name: EStrategyOptionsName.LAUNCH },
];

const STRATEGY_MAP_BY_ID: { [key: number]: string } = {
  1: 'marketing',
  2: 'sales',
  3: 'remarketing',
  4: 'nurturing',
  5: 'lead-generation',
  6: 'lead-recovery',
  7: 'cross-selling',
  8: 'up-selling',
  9: 'launch',
  10: 'other',
};

export {
  EStrategyOptionsName,
  STRATEGY_MAP_BY_ID,
  STRATEGY_OPTIONS,
  TRANSLATE_MODAL,
  TRANSLATE_MODAL_INPUTS,
};
